import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import SuccessIcon from '../../Icons/SuccessIcon';
import WarningIcon from '../../Icons/WarningIcon';

import useStyles from '../Details/makeStyles';

const IncludedInsuranceList = ({ plan }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Grid>
        {plan.descriptions.map((n) => (
          <Grid container direction="row" key={`${plan.label}-desc-${n}`}>
            <Grid item className={classes.icon}>
              <SuccessIcon />
            </Grid>
            <Grid item xs={11} className={classes.label}>
              <Typography>
                { t(`travel.types.${plan.label}.description${n}`) }
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Grid>
        {plan.warnings.map((n) => (
          <Grid container direction="row" key={`${plan.label}-warn-${n}`}>
            <Grid item className={classes.icon}>
              <WarningIcon />
            </Grid>
            <Grid item xs={11} className={classes.label}>
              <Typography className={classes.warningText}>
                { t(`travel.types.${plan.label}.warning${n}`) }
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

IncludedInsuranceList.propTypes = {
  plan: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    warnings: PropTypes.arrayOf(PropTypes.number),
    descriptions: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
};

export default IncludedInsuranceList;
